import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { RequestSubForm } from '../request-sub-form.component';

@Component({
    selector: 'switch-request-form',
    templateUrl: './switch-request-form.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwitchRequestFormComponent extends RequestSubForm {
  pageName = 'RequestSwitch';
}
